import "xstyle/css!app/css/geo-field.css";
// generates controls for the geoquery, each control should have an outer <div> with an id corresponding to the fieldInfo name
// the actual input control should be contained within the div and have a name matching the fieldInfo name
// TODO: these need to be decomposed and replaced with the more advanced app/test/controls
import Utils = require("../utils");
import $ = require("jquery");
import _ = require("underscore");

function asId(fieldInfo: Rhythm.GIS.FieldInfo) {
    return `geo-field-${fieldInfo.name}`;
}

function getDefaultValue<T>(fieldInfo: Rhythm.GIS.FieldInfo, orElse?: T) {
    var defaultValue = Utils.extend(fieldInfo);
    defaultValue = defaultValue && defaultValue["defaultValue"];
    if (typeof defaultValue === "undefined") defaultValue = orElse;
    return <T>defaultValue;
}

function setDefaultValue(fieldInfo: Rhythm.GIS.FieldInfo, value) {
    Utils.extend(fieldInfo, { defaultValue: value });
}

class BaseInput {
    $el: JQuery;
    className = "geo-field";

    constructor(public fieldInfo: Rhythm.GIS.FieldInfo) {
        this.$el = $(this.template());
    }

    get id() {
        return asId(this.fieldInfo);
    }

    template() {
        let fieldInfo = this.fieldInfo;
        let id = this.id;
        return `
<div class="${this.className} ${this.className}-${fieldInfo.controlType}">
<label for=${id}>${fieldInfo.alias}</label><div class='container'>
</div>
`;
    }

    val() {
        return null;
    }

    append(el: JQuery) {
        let container = $(".container", this.$el);
        if (!container.length) container = this.$el;
        container.append(el);
    }

    appendTo(el: JQuery) {
        this.$el.appendTo(el);
    }

}

class TextInput extends BaseInput {

    template() {
        let fieldInfo = this.fieldInfo;
        let id = this.id;
        let defaultValue = getDefaultValue(fieldInfo, "");

        return `
<div class="${this.className} ${this.className}-${fieldInfo.controlType}">
<label for=${id}>${fieldInfo.alias}</label>
<input type="${fieldInfo.controlType}" id="${id}" name="${id}" ${fieldInfo.length ? 'maxlength="fieldInfo.length"' : ''} value="${defaultValue}" />
</div>
`;

    }

    val() {
        let value = $(`#${this.id}`, this.$el).val();
        return value ? value : null;
    }
}

class DateInput extends TextInput {

    val() {
        return super.val() ? new Date(super.val()) : null;
    }
}

class NumberInput extends TextInput {

    val() {
        return super.val() ? parseFloat(super.val()) : null;
    }
}

class DomainControl extends BaseInput {

    template() {
        let fieldInfo = this.fieldInfo;
        let codedValues = <Array<{ name: string; code: number }>>fieldInfo.domain["codedValues"];
        let defaultValues = Utils.split("" + (Utils.extend(this.fieldInfo).defaultValue || ""));

        return `
<div name="${fieldInfo.name}" class="geo-field domain-control">
  <label>${fieldInfo.alias || fieldInfo.name}</label>
  <div class="domain-group">
    ${codedValues.map(d => {
                let checked = -1 < defaultValues.indexOf("" + d.code) ? "checked" : "";
                return `<label><input type="checkbox" class="domain-item ${fieldInfo.name}" value="${d.code}" ${checked} />${d.name}</label>`;
            }).join("") }
  </div>
</div>
`;

    }

    val() {
        let selected = $(".domain-item:checked", this.$el);

        switch (selected.length) {
            case 0:
                return null;
            case 1:
                let value = selected.val();
                return value ? value : null;
                break;
            default:
                let values = selected.toArray().map(el => el.value);
                return values;
        }

    }

}


class GeoQueryControlFactory {

    static about = `
Generates controls for the geoquery, each control should have an outer <div> with an id corresponding to the fieldInfo name.
The actual input control should be contained within the div and have a name matching the fieldInfo name.
Used by [geoquery-form-tool](#app/controls/base/geoquery-form-tool).
    `;

    private _controls: Rhythm.GIS.Dictionary<BaseInput>;

    constructor() {
        this._controls = {};
    }

    public asForm() {
        return $("<form>");
    }

    asId(fieldInfo: Rhythm.GIS.FieldInfo) {
        return asId(fieldInfo);
    }

    getField(form: JQuery, fieldInfo: Rhythm.GIS.FieldInfo) {
        let id = this.asId(fieldInfo);
        return this._controls[id].$el;
    }

    getValue(form: JQuery, fieldInfo: Rhythm.GIS.FieldInfo) {
        let id = this.asId(fieldInfo);
        let control = this._controls[id];
        // control can be undefined if it is on the blacklist or disabled
        return control ? control.val() : null;
    }

    replace(fieldInfo: Rhythm.GIS.FieldInfo, control: BaseInput) {
        let id = this.asId(fieldInfo);
        let oldControl = this._controls[id];
        this._controls[id] = control;
        oldControl.$el.replaceWith(control.$el);
    }

    asControl(fieldInfo: Rhythm.GIS.FieldInfo): BaseInput {
        var builder = this.defaultBuilder;
        if (!fieldInfo.controlType) {
            fieldInfo.controlType = fieldInfo.type;
        }

        if (!fieldInfo.alias) {
            fieldInfo.alias = fieldInfo.name;
        }

        builder = this[`${fieldInfo.controlType}Builder`] || this.defaultBuilder;

        let control = <BaseInput>builder.apply(this, [fieldInfo]);
        this._controls[control.id] = control;

        return control;
    }

    private stringBuilder(fieldInfo: Rhythm.GIS.FieldInfo) {
        return new TextInput(fieldInfo);
    }

    private dateBuilder(fieldInfo: Rhythm.GIS.FieldInfo) {
        var defaultValue = getDefaultValue(fieldInfo, 0);
        if (typeof defaultValue === "number") {
            setDefaultValue(fieldInfo, Utils.addDay(new Date(), defaultValue).toDateString());
        }
        return new DateInput(fieldInfo);
    }

    private domainBuilder(fieldInfo: Rhythm.GIS.FieldInfo) {
        return new BaseInput(fieldInfo);
    }

    private checkboxBuilder(value: { name: string; code: string|number; }) {
        return $(`<label><input type="checkbox" value="${value.code}"/>${value.name}</label>`);
    }

    private radioBuilder(id: string, value: { name: string; code: string|number; }, checked = false) {
        return $(`<label><input type="radio" name="${id}" value="${value.code}" ${checked ? "checked" : ""} />${value.name}</label>`);
    }

    private objectBuilder(fieldInfo: Rhythm.GIS.FieldInfo) {
        return new BaseInput(fieldInfo);
    }

    private numberBuilder(fieldInfo: Rhythm.GIS.FieldInfo) {
        if (fieldInfo.domain) {
            let codedValues = <Array<{ name: string; code: number }>>fieldInfo.domain["codedValues"];
            if (codedValues && codedValues.length) {
                return new DomainControl(fieldInfo);
            }
        }
        return new NumberInput(fieldInfo);
    }

    private defaultBuilder(fieldInfo: Rhythm.GIS.FieldInfo) {
        return new BaseInput(fieldInfo);
    }
}

export = GeoQueryControlFactory;
